import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import TaskmanagementBanner from "./task-mangement-banner";
import TaskmanagementInfo from "./task-management-info";
function AICustomerSupport() {
  return (
    <>
      <Header />
      <main>
        <TaskmanagementBanner />
        <TaskmanagementInfo />
      </main>
      <Footer />
    </>
  );
}

export default AICustomerSupport;
